import axios from "axios";

const API_URL = `${import.meta.env.VITE_API_URL}/categories`;

// Types
export interface CategoryBranch {
  _id: string;
  name: string;
}

export interface CategoryProduct {
  _id: string;
  name: string;
}

export interface Category {
  _id: string;
  name: string;
  branch: CategoryBranch;
  products: CategoryProduct[];
  createdAt: string;
  updatedAt: string;
}

export interface CategoriesListResponse {
  categories: Category[];
  page: number;
  pages: number;
  total: number;
}

export interface CategoriesAllResponse {
  categories: Category[];
}

export interface CategorySearchOptions {
  page: number;
  sortBy: string;
  sortOrder: string;
  search: string;
}

// API functions
export const fetchCategories = async (
  searchOptions: CategorySearchOptions
): Promise<CategoriesListResponse> => {
  const { data } = await axios.get(
    `${API_URL}?page=${searchOptions.page}&sortBy=${searchOptions.sortBy}&sortOrder=${searchOptions.sortOrder}&search=${searchOptions.search}`
  );
  return data;
};

export const fetchCategoriesAll = async (): Promise<Category[]> => {
  const { data } = await axios.get<CategoriesAllResponse>(`${API_URL}/all`);
  return data.categories;
};

export const fetchCategory = async (id: string): Promise<Category> => {
  const { data } = await axios.get(`${API_URL}/${id}`);
  return data.data;
};

export const fetchCategoryByName = async (
  name: string,
  branchName?: string
): Promise<Category | null> => {
  const { data } = await axios.get<CategoriesAllResponse>(`${API_URL}/all`);
  const category = data.categories.find(
    (c) =>
      c.name.toLowerCase() === name.toLowerCase() &&
      (!branchName || c.branch.name.toLowerCase() === branchName.toLowerCase())
  );
  return category || null;
};

export const createCategory = async (
  category: { name: string; branch: string }
): Promise<{ message: string; category: Category }> => {
  const { data } = await axios.post(API_URL, category);
  return data;
};

export const updateCategory = async (
  category: Partial<Category> & { _id: string }
): Promise<{ message: string }> => {
  const { data } = await axios.put(API_URL, category);
  return data;
};

export const deleteCategory = async (id: string): Promise<{ message: string }> => {
  const { data } = await axios.delete(`${API_URL}/${id}`);
  return data;
};
